import { useState } from 'react';
import { MediumHeightDivider, SmallHeightDivider, StyledPagination } from '../../../../theme/Styles';
import Fade from 'react-reveal/Fade';
import DocumentsOfRequestsCard from '../../../../components/DocumentsOfRequestsCard/DocumentsOfRequestsCard';
import { useQuery, useQueryClient } from 'react-query';
import { getInstitutionalDocuments } from '../../../../api/MyInstitutionalDocuments';
import { DocumentsContainer, SectionTitle } from '../../styles/MyDeskStyles';
import { format } from 'date-fns';
import COLORS from '../../../../theme/Colors';
import { replaceGuionToSlashFromString } from '../../../../utilities/functions/StringUtil';
import CenterLoading from '../../../../components/CenterLoading/CenterLoading';

const PAGE_SIZE = 10;

async function fetchAllInstitutionalDocuments(citizenID) {
    const firstPage = await getInstitutionalDocuments(citizenID, 1);
    let allData = firstPage?.data || [];
    const lastPage = Math.min(firstPage?.last_page || 1, 25);
    if (lastPage > 1) {
        const promises = [];
        for (let p = 2; p <= lastPage; p++) {
            promises.push(getInstitutionalDocuments(citizenID, p).catch(() => null));
        }
        const results = await Promise.all(promises);
        results.forEach(res => {
            if (res?.data) allData = allData.concat(res.data);
        });
    }
    return allData;
}

function MyInstitutionalDocuments({ searchQuery = '' }) {

    const queryClient = useQueryClient();
    const userData = queryClient.getQueryData(['userData']);
    const citizenID = userData?.payload?.citizen_id;

    const [currentPage, setCurrentPage] = useState(1);

    const { data: allDocuments, isLoading: institutionalDocumentsDataLoading } = useQuery(
        ['institutionalDocumentsData', citizenID],
        () => fetchAllInstitutionalDocuments(citizenID),
        { enabled: !!citizenID }
    );

    const handleChangePage = (page) => {
        setCurrentPage(page);
    }

    const normalizedQuery = searchQuery.trim().toLowerCase();

    const filteredDocuments = (allDocuments || [])
        .filter((document) => !normalizedQuery || String(document.name || '').toLowerCase().includes(normalizedQuery))
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

    const totalFiltered = filteredDocuments.length;
    const lastPage = Math.max(1, Math.ceil(totalFiltered / PAGE_SIZE));
    const validPage = Math.min(currentPage, lastPage);
    const pageDocuments = filteredDocuments.slice((validPage - 1) * PAGE_SIZE, validPage * PAGE_SIZE);

    const documentsDataForShow = pageDocuments.map((document) => {
        const typeForName = document.extension === "vnd.ms-excel" ? "xls" :
            document.extension === "vnd.openxmlformats-officedocument.spreadsheetml.sheet" ?
                "xlsx" : document.extension
        return {
            name: `${document.name}.${typeForName}`,
            documentType: document.extension,
            date: format(new Date(replaceGuionToSlashFromString(document.created_at)), 'yyyy-MM-dd HH:mm:ss'),
            url: document.url,
            type: document.extension
        }
    })

    if (institutionalDocumentsDataLoading) return <CenterLoading/>
    return (
        <Fade right >
            {
                totalFiltered > 0 ?
                    <DocumentsContainer style={{ padding: 0 }}>
                        <DocumentsOfRequestsCard data={documentsDataForShow} />
                        <SmallHeightDivider />
                        <StyledPagination count={lastPage} page={validPage}
                            onChange={(event, page) => {
                                handleChangePage(page);
                            }} variant="outlined" shape="rounded" sx={{ color: COLORS.primary }} />
                    </DocumentsContainer>
                    :
                    <SectionTitle>
                        {normalizedQuery ? 'No hay documentos recibidos que coincidan con la búsqueda' : 'No hay documentos recibidos'}
                    </SectionTitle>
            }
        </Fade>

    );
}

export default MyInstitutionalDocuments;
